import store from "../vuex/store.js";

export default {
  name: "SnackbarMixin",
  methods: {
    $snackbarInfo(message) {
      store.dispatch("snackInfo", message);
    },
    $snackbarError(message) {
      store.dispatch("snackError", message);
    },
    $snackbarSuccess(message) {
      store.dispatch("snackSuccess", message);
    }
  }
};
